import { useMemo, useState } from "react";
import { MRT_ColumnDef } from "material-react-table";
import VirtualizedTable from "./VirtualizeTable";
import { formatDate } from "../helpers/format";
import { Button, Chip } from "@mui/material";
import ConfirmCheckIn from "./GympassCheckIn";

type CheckIn = {
  id: number;
  status: string;
  gymName: string;
  productName: string;
  timestamp: string;
  createdAt: string;
  updatedAt: string;
};

const CheckInTable = ({ data, refetch }: { data: CheckIn[]; refetch: any }) => {
  const [checkInQueue, setCheckInQueue] = useState<any>(null);
  const [openCheckIn, setOpenCheckIn] = useState(false);
  const columns = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "name",
        header: "Nome",
        Cell: ({ row }) =>
          `${row?.original?.gympassStudent?.first_name ?? ""} ${
            row?.original?.gympassStudent?.last_name ?? ""
          }`,
      },
      {
        accessorKey: "status",
        header: "Status",
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },

        Cell: ({ cell }) => {
          const status = cell.getValue() as string;
          let color: any = "";
          let label = status;

          if (status === "PENDING") {
            color = "warning";
            label = "Pendente";
          }

          if (status === "CONFIRMED") {
            color = "success";
            label = "Confirmado";
          }

          if (status === "EXPIRED") {
            label = "Expirado";
          }

          if (status === "DELETED") {
            label = "Excluido";
          }

          if (status === "CANCELED") {
            color = "error";
            label = "Não autorizado";
          }

          return (
            <Chip
              label={label}
              color={color}
              sx={{ color: "#fff", width: "100%" }}
            />
          );
        },
      },

      {
        accessorKey: "createdAt",
        header: "Criado em",
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        Cell: ({ cell }) => formatDate(cell.getValue<string>()),
      },

      {
        id: "detalhes",
        header: "Ações",
        Cell: ({ row }) =>
          row?.original?.status === "PENDING" ? (
            <Button
              variant="contained"
              color="success"
              fullWidth
              onClick={() => {
                setOpenCheckIn(true);
                setCheckInQueue({
                  checkinId: row?.original?.id,
                  name: `${row?.original?.gympassStudent?.first_name ?? ""} ${
                    row?.original?.gympassStudent?.last_name ?? ""
                  }`,
                  email: row?.original?.gympassStudent?.email,
                  phone: row?.original?.gympassStudent?.phone,
                });
              }}
            >
              Confirmar check-in
            </Button>
          ) : (
            "--"
          ),
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
      },
    ],
    []
  );

  return (
    <>
      <VirtualizedTable
        data={data}
        columns={columns}
        fetchNextPage={() => Promise.resolve()}
        isLoading={false}
      />
      <ConfirmCheckIn
        open={openCheckIn}
        data={checkInQueue}
        refetch={refetch}
        onClose={() => {
          setOpenCheckIn(false);
          setCheckInQueue(null);
        }}
      />
    </>
  );
};

export default CheckInTable;
